import { useRouteError, Link } from "react-router-dom";
import "./ErrorPage.scss";

const ErrorPage = () => {
  const error = useRouteError();
  console.error(error);

  return (
    <div className="error-page">
      <h1 className="error-page__title">404 Error</h1>
      <h2 className="error-page__subtitle">Page Not Found</h2>
      <p className="error-page__message">{error.message || error.statusText}</p>
      <Link to="/" className="error-page__link">
        Return to Home
      </Link>
    </div>
  );
};

export default ErrorPage;
